// extracted by mini-css-extract-plugin
module.exports = {"app-center-display":"components-AppCenterDisplay-AppCenterDisplay__app-center-display--2gh5J"};